export const upperCaseFirst = string => {
  if (string.trim() === '') {
    return ''
  }

  const [first, ...rest] = string
  return `${first.toUpperCase()}${rest.join('')}`
}

export const stringToInt = value =>
  value && !Number.isNaN(Number(value)) ? parseInt(value, 10) : null
